import React, { useEffect, useRef, useState } from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { useIsMount } from '@yme/common/hooks';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2, HeadingLevel3, HeadingLevel4 } from '@yme/tokens/typography';
import { noop } from '@yme/utils/common';
import { MAX_CARDS_NUMBER_FOR_ONE_ROW } from './constants';
import { ContentBlockStyled, DescriptionTextStyled, HiddenWrapperStyled } from './styled';
export function CardDesktopContent({ button, description, subtitle, title, isRightToLeft, numberOfCards, bottomMargin, setContentHeight, countLineVisible, parentCardHeight, }) {
    const [hiddenPartHeight, setHiddenPartHeight] = useState(0);
    const [visiblePartHeight, setVisiblePartHeight] = useState(0);
    const isMount = useIsMount();
    const visibleRef = useRef(null);
    const HiddenRef = useRef(null);
    useEffect(() => {
        if (visibleRef?.current) {
            const offsetHeight = Math.ceil(visibleRef.current?.offsetHeight);
            setVisiblePartHeight(offsetHeight);
        }
    }, [visibleRef]);
    useEffect(() => {
        if (!isMount && HiddenRef?.current) {
            const offsetHeight = Math.ceil(HiddenRef.current?.offsetHeight);
            setHiddenPartHeight(offsetHeight);
        }
    }, [HiddenRef, isMount]);
    useEffect(() => {
        if (hiddenPartHeight !== 0 && visiblePartHeight !== 0) {
            const contentHeight = hiddenPartHeight + visiblePartHeight;
            setContentHeight(contentHeight);
        }
    }, [hiddenPartHeight, setContentHeight, visiblePartHeight]);
    return (React.createElement(ContentBlockStyled, { flexDirection: "column", bottom: bottomMargin, hiddenPartHeight: hiddenPartHeight, visiblePartHeight: visiblePartHeight, parentCardHeight: parentCardHeight },
        React.createElement("div", { ref: visibleRef },
            subtitle && (React.createElement(FlexWrapper, { mb: "4px" },
                React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, subtitle))),
            React.createElement(FlexWrapper, null, numberOfCards === MAX_CARDS_NUMBER_FOR_ONE_ROW ? (React.createElement(HeadingLevel3, { color: colorCoreWhite1000 }, title)) : (React.createElement(HeadingLevel2, { color: colorCoreWhite1000 }, title)))),
        React.createElement(HiddenWrapperStyled, { ref: HiddenRef },
            description && (React.createElement(FlexWrapper, null,
                React.createElement(DescriptionTextStyled, { color: colorCoreWhite1000, countLineVisible: countLineVisible }, description))),
            React.createElement(FlexWrapper, { pt: "16px" },
                React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, isRightToLeft: isRightToLeft, size: SIZE_44, label: button.text, isDarkMode: true, width: "auto", onClick: noop })))));
}
